import getApi from '../../api'
import { AssigningAuthority } from '../../model/Patient'

export const getAssigningAuthorithies = () =>
  getApi().get<Array<AssigningAuthority>>('/assigning_authorities')
